import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation.json';
import frTranslation from './locales/fr/translation.json';
// import countries from "i18n-iso-countries";
// import * as moment from "moment/moment.js";
// import "moment/locale/en-gb"
// import "moment/locale/fr"

// countries.registerLocale(require("i18n-iso-countries/langs/fr.json"))


//setting moment local from wpml locale

// function getCookie(cname) {
//   var name = cname + "=";
//   var decodedCookie = decodeURIComponent(document.cookie);
//   var ca = decodedCookie.split(';');
//   for(var i = 0; i <ca.length; i++) {
//     var c = ca[i];
//     while (c.charAt(0) === ' ') {
//       c = c.substring(1);
//     }
//     if (c.indexOf(name) === 0) {
//       return c.substring(name.length, c.length);
//     }
//   }
//   return "";
// }

//default locale for moment
// moment.locale("fr")

// try{
//     let lang=getCookie("wp-wpml_current_language");
//     if(lang!==""){
//         if(lang==="en"){
//             moment.locale("en-gb");
//         }else{
//             moment.locale(lang)
//         }
//         countries.registerLocale(require("i18n-iso-countries/langs/"+lang+".json"))
//     }
// }catch{};

const resources = {
    fr: {
        translation: frTranslation
    },
    en: {
        translation: enTranslation
    }
};

const options = {
    order: ['querystring', 'cookie'],
    lookupQuerystring: 'lang',
    lookupCookie: 'wp-wpml_current_language',
    cookieMinutes: 10,
};


i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .use(LanguageDetector)
    .init({
        resources,
        fallbackLng: 'fr',
        lng: 'fr',
        detection: options,
        keySeparator: false, // we do not use keys in form messages.welcome
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

i18n.changeLanguage();

export default i18n;
